import React, { FocusEvent, KeyboardEvent } from 'react';
import { Heading, Breadcrumbs, BreadcrumbsText, Link, ErrorText, TextBlock, Button } from 'neon-design-system';
import { makeStyles, createStyles, Box, Paper } from '@material-ui/core';
import EditBlock from '../EditBlock';

const useStyles = makeStyles(theme => createStyles({
	mainDiv: {
		marginTop: theme.spacing(2)
	},
	heading1: {
		marginBottom: theme.spacing(2),
		width: '100%'

	},
	heading2: {
		marginTop: theme.spacing(2)
	},
	divider: {
		marginTop: theme.spacing(4),
		marginBottom: theme.spacing(4)
	},
	error: {
		color: theme.palette.error.dark
	}
}));

export interface AddEditHeaderProps {
	isNew: boolean;
	entityName: string;
	pathArea: string;
	returnUrl: string;
	editableHeader?: boolean;
	editablePlaceholder: string | undefined;
	errorMessage: string | undefined;
	value: string;
	onBlur?: (event: FocusEvent<any>) => void;
	onChange?: (value: string) => void;
	isResumeMessageVisible?: {
		onResume: () => void;
		onDiscard: () => void;
	};
}

export const AddEditHeader = (props: AddEditHeaderProps) => {
	const classes = useStyles();

	const title = props.isNew ? `Add a new ${props.entityName}` : `Edit a ${props.entityName}`;
	const pathOperation = props.isNew ? `New ${props.entityName}` : `Edit ${props.entityName}`;

	return (
		<div className={classes.mainDiv}>
			<div className={classes.heading1}>
				<Breadcrumbs >
					<Link to={props.returnUrl}>{props.pathArea}</Link >
					<BreadcrumbsText>{pathOperation}</BreadcrumbsText>
				</Breadcrumbs>
			</div>
			{
				props.isResumeMessageVisible ? (
					<Paper>
						<Box p={4}>
							<Box mb={1}>
								<Heading styleName="headline1" color="white">Unpublished content – Resume editing?</Heading>
							</Box>
							<Box mb={2}>
								<TextBlock styleName="body" color="grey" shade={200}>
									The content you were editing before was automatically saved, so you don’t lose it.
									Do you want to resume editing or discard the content and start from scratch?
								</TextBlock>
							</Box>
							<Box display="flex">
								<Box mr={1}>
									<Button
										colorType="primary"
										onClick={() => props.isResumeMessageVisible?.onResume?.()}
									>
										Resume editing
									</Button>
								</Box>
								<Box>
									<Button
										colorType="grey"
										onClick={() => props.isResumeMessageVisible?.onDiscard?.()}
									>
										Discard content
									</Button>
								</Box>
							</Box>
						</Box>
					</Paper>
				) : <></>
			}
			<div className={classes.heading2}>
				{!props.editableHeader &&
					<Heading styleName="title1">{title}</Heading>
				}

				{props.editableHeader &&
					<EditBlock
						id="article-add-edit-title"
						value={props.value}
						placeholder={props.editablePlaceholder}
						onKeyDown={(event: KeyboardEvent<HTMLTextAreaElement>) => {
							// https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
							const enterKeyCode = 13;
							if (event.keyCode === enterKeyCode) {
								event.preventDefault();
							}
						}}
						onChange={(event: any) => {
							props.onChange?.(event.target.value);
						}}
						onBlur={props.onBlur}/>
				}
				<ErrorText>{props.errorMessage}</ErrorText>
			</div>
		</div >
	);
};

export default AddEditHeader;
